import { Button } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useCreateNewConversionEvent } from '../../hooks/useCreateNewConversionEvent';
import { EventCard } from '../EventCard/EventCard';
import styles from './conversionEvents.module.scss';

const stepTwo = 2;
export const ConversionEvents = ({
    conversions = [],
    goNext,
    handleSetCurrentIndex,
    handleEditClick,
    resetSteps,
    setFocusedConversionId,
}) => {
    const { handleNewEventButton } = useCreateNewConversionEvent({
        goNext,
        handleSetCurrentIndex,
        setFocusedConversionId,
    });

    return (
        <div className={styles['container']}>
            <div className={styles['events-wrapper']}>
                {conversions.map(event => (
                    <EventCard
                        event={event}
                        key={event.id}
                        resetSteps={resetSteps}
                        setFocusedConversionId={setFocusedConversionId}
                        onClick={() => handleEditClick(event.id, stepTwo)}
                    />
                ))}
            </div>
            <footer className={styles['footer']}>
                <Button
                    onClick={handleNewEventButton}
                    variant={Button.variant.primary}
                    size={Button.size.md}
                    aria-label="New Event"
                    className={styles['button']}
                >
                    <FormattedMessage id="codeless.conversion.event.new.button" defaultMessage="+ New Event" />
                </Button>
            </footer>
        </div>
    );
};
